module.exports = __webpack_public_path__ + "img/throat.45c942ed.svg";